export enum Breakpoint {
  MOBILE = 'xs',
  TABLET = 'md',
  DESKTOP = 'lg'
}
